import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IgnatiusState } from '../_reducers/ignatius.reducers';

const getIGFeatureState = createFeatureSelector<IgnatiusState>('ignatius');

/**
 * Select ignatius state
 */
export const getIGState = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state
);

/**
 * Select query report
 */
export const getQueryReport = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state.queryReport
);

/**
 * Select query report
 */
export const getApplicationData = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state.applicationData
);

/**
 * Select error
 */
export const getAuthError = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state.error
);

/**
 * Select dropdown
 */
export const getDropdown = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state.dropdown
);

/**
 * Select Id -> Name mapping
 */
export const getFieldMapping = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state.fieldsMapping
);

/**
 * Select operations
 */
 export const getIGOperations = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state.operations
);

/**
 * Select conditional query report
 */
export const getConditionalQueryReport = createSelector(
  getIGFeatureState,
  (state: IgnatiusState) => state.conditionalQueryReport
);
